import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DispatchBoardPanels } from "../../shared/enums/DispatchBoardPanels";
import { DispatchBoardService } from '../../shared/services/dispatch-board.service';
import { DispatchBoardSearch } from '../../shared/models/DispatchBoardSearch';
import { GlobalsService } from '../../shared/services/globals.service';

@Component({
    selector: 'cp-dispatch-board-widget',
    templateUrl: './dispatch-board-widget.component.html',
    styleUrls: ['./dispatch-board-widget.component.scss']
})
export class DispatchBoardWidgetComponent implements OnInit {

    constructor(private svc_globals: GlobalsService, private svc_data: DispatchBoardService) { }

    @Input() filterString: string = '';
    @Input() parentPanel: DispatchBoardPanels;
    @Input() inputData: any = { description: 'Title', value: '000' };
    data: any = [];

    showContactFlag: boolean = false;

    ngOnInit() {
        //if (this.inputData.personId) {
        //    this.svc_data.getTechAssignments(this.inputData.personId).subscribe(data => {
        //        this.data.push(data);

        //        if (data && data.error) {
        //            alert('got an error back!');
        //        }

        //    });
        //}
    }
    public popupClass: string = 'cp-light-popup';
    @Output() popupLock = new EventEmitter<boolean>();

    public lockPopups(lock: boolean) {
        this.popupLock.emit(lock);
    }

    showContactHover(state: boolean){
        this.showContactFlag = state;
    }

	sampleMenu: Array<any> = [{
		text: 'Move',
		icon: 'arrows-alt'
	}, {
		text: 'Hide',
		icon: 'eye-slash'
	}, {
		text: 'View Dispatches',
		icon: 'th'
	}];
}

